<template>
	<div>
		<div class="mainTitle text-center my-3">
            <h3 class="mb-4">{{$t('myAccounts')}}</h3>
            <message-component :message="response_msg" :messageType="msg_type"></message-component>
        </div> 
		<div class="whiteBG radius pt-3">  
			<div class="d-flex flex-wrap tabcenter justify-content-between border-bottom pb-3 mb-2">
				<div class="accountType  d-flex justify-content-start align-items-center">
					<a href="#" @click="accountTypeVar = '1'" :class="(accountTypeVar == '1')?'active' : ''">{{$t('liveAccount')}}</a>
					<a :class="(accountTypeVar == '0')?'active' : ''" href="#" @click="accountTypeVar = '0'">{{$t('demoAccount')}}</a>
				</div>	
				<!--<div class="requestbtn d-flex align-items-center">
					<filter-component></filter-component>
				</div>-->
			</div> 
			<live-account v-if="accountTypeVar == '1'" :pageLoader1="pageLoader"></live-account>
			<demo-account v-if="accountTypeVar == '0'" :pageLoader1="pageLoader"></demo-account>
		</div>
	</div>
</template>
<script>
	import live_account_list from './live_account_list'
	import demo_account_list from './demo_account_list'
    import { fxViewMixins } from '@/plugins/fxView'
    import { Const } from '@/plugins/fxView/provider/candle-history/lib/const.cls'
    export default {
        name: 'Trading-Account-List',
        mixins: [fxViewMixins],
        data() {
            return { 
            	//============message and loader ===========
                response_msg : '',
                msg_type : '',
                pageLoader : false,
                //==========================================
            	accountTypeVar : '1',
            }
        },
        components: {
            liveAccount: live_account_list,
            demoAccount: demo_account_list
        },
        created(){
			//comes from create demo/live account page
			if(this.$route.params.accountTypeVar){
				this.accountTypeVar = this.$route.params.accountTypeVar
			}
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/manageAccounts/account_list.vue